module.exports = __webpack_public_path__ + "img/line_QR.3a6fc0ed.jpg";